// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScoresTable-module__font-s-10___rfHGo {
  font-size: 10px !important;
}

.ScoresTable-module__font-s-12___GpcpO {
  font-size: 12px !important;
}

.ScoresTable-module__font-s-13___rdLZU {
  font-size: 13px !important;
}

.ScoresTable-module__font-s-14___gBOvf {
  font-size: 14px !important;
}

.ScoresTable-module__font-s-15___HAEhs {
  font-size: 15px !important;
}

.ScoresTable-module__font-s-16___JLxL4 {
  font-size: 16px !important;
}

.ScoresTable-module__font-s-18___hVc3e {
  font-size: 18px !important;
}

.ScoresTable-module__font-s-20___l0UGf {
  font-size: 20px !important;
}

.ScoresTable-module__font-s-22___dhUmv {
  font-size: 22px !important;
}

.ScoresTable-module__font-s-28___nMoAV {
  font-size: 28px !important;
}

.ScoresTable-module__font-w-400___VMTp3 {
  font-weight: 400 !important;
}

.ScoresTable-module__font-w-500___b20JF {
  font-weight: 500 !important;
}

.ScoresTable-module__font-w-600___vwDBN {
  font-weight: 600 !important;
}

.ScoresTable-module__font-w-700___NeXqK {
  font-weight: 700 !important;
}

.ScoresTable-module__p-5___hNCSd {
  padding: 5px !important;
}

.ScoresTable-module__p-12___uti8o {
  padding: 12px !important;
}

.ScoresTable-module__p-16___BrEc0 {
  padding: 16px !important;
}

.ScoresTable-module__p-30___oLTPq {
  padding: 30px !important;
}

.ScoresTable-module__p-b-0___nWl07 {
  padding-bottom: 0 !important;
}

.ScoresTable-module__p-b-5___xahR_ {
  padding-bottom: 5px !important;
}

.ScoresTable-module__p-b-10___PLMAf {
  padding-bottom: 10px !important;
}

.ScoresTable-module__p-b-12___g2zwV {
  padding-bottom: 12px !important;
}

.ScoresTable-module__p-b-16___EjSmY {
  padding-bottom: 16px !important;
}

.ScoresTable-module__p-b-18___g_tE1 {
  padding-bottom: 18px !important;
}

.ScoresTable-module__p-b-20___Mzfxe {
  padding-bottom: 20px !important;
}

.ScoresTable-module__p-b-25___MTxkF {
  padding-bottom: 25px !important;
}

.ScoresTable-module__p-b-30___ac1W9 {
  padding-bottom: 30px !important;
}

.ScoresTable-module__p-b-50___MSrJO {
  padding-bottom: 50px !important;
}

.ScoresTable-module__p-t-0___ozEO0 {
  padding-top: 0 !important;
}

.ScoresTable-module__p-t-12___0n517 {
  padding-top: 12px !important;
}

.ScoresTable-module__p-t-16___WvIqk {
  padding-top: 16px !important;
}

.ScoresTable-module__p-t-18___wvBxJ {
  padding-top: 18px !important;
}

.ScoresTable-module__p-t-20___NqrQb {
  padding-top: 20px !important;
}

.ScoresTable-module__p-t-30___foC3a {
  padding-top: 30px !important;
}

.ScoresTable-module__p-t-40___Pm2J6 {
  padding-top: 40px !important;
}

.ScoresTable-module__p-t-50___h2FBZ {
  padding-top: 50px !important;
}

.ScoresTable-module__p-l-20___rUSKA {
  padding-left: 20px !important;
}

.ScoresTable-module__p-l-30___oH8xk {
  padding-left: 30px !important;
}

.ScoresTable-module__p-l-40___Xrqiv {
  padding-left: 40px !important;
}

.ScoresTable-module__p-r-16___coStE {
  padding-right: 16px !important;
}

.ScoresTable-module__p-r-20___jxqbD {
  padding-right: 20px !important;
}

.ScoresTable-module__p-r-30___CMsgf {
  padding-right: 30px !important;
}

.ScoresTable-module__p-r-50___Kri5s {
  padding-right: 50px !important;
}

.ScoresTable-module__p-r-60___CPhNn {
  padding-right: 60px !important;
}

.ScoresTable-module__m-b-1___EV6DG {
  margin-bottom: 1px !important;
}

.ScoresTable-module__m-b-2___ed9a_ {
  margin-bottom: 2px !important;
}

.ScoresTable-module__m-b-6___wvxPG {
  margin-bottom: 6px !important;
}

.ScoresTable-module__m-b-8___eIuHs {
  margin-bottom: 8px !important;
}

.ScoresTable-module__m-b-10___A1yzC {
  margin-bottom: 10px !important;
}

.ScoresTable-module__m-b-14___I_KEc {
  margin-bottom: 14px !important;
}

.ScoresTable-module__m-b-16___buxR_ {
  margin-bottom: 16px !important;
}

.ScoresTable-module__m-b-20___yS6tH {
  margin-bottom: 20px !important;
}

.ScoresTable-module__m-b-22___RrtAI {
  margin-bottom: 22px !important;
}

.ScoresTable-module__m-b-24___TaYwF {
  margin-bottom: 24px !important;
}

.ScoresTable-module__m-b-30___WVbVP {
  margin-bottom: 30px !important;
}

.ScoresTable-module__m-b-32___gOuQE {
  margin-bottom: 32px !important;
}

.ScoresTable-module__m-b-40___iRERl {
  margin-bottom: 40px !important;
}

.ScoresTable-module__m-t-2___GSUHy {
  margin-top: 2px !important;
}

.ScoresTable-module__m-t-3___U1Pt0 {
  margin-top: 3px !important;
}

.ScoresTable-module__m-t-4___g5cIc {
  margin-top: 4px !important;
}

.ScoresTable-module__m-t-5___NTdoe {
  margin-top: 5px !important;
}

.ScoresTable-module__m-t-8___FDU5I {
  margin-top: 8px !important;
}

.ScoresTable-module__m-t-10___xdyfn {
  margin-top: 10px !important;
}

.ScoresTable-module__m-t-15___TuK0z {
  margin-top: 15px !important;
}

.ScoresTable-module__m-t-16___t04ig {
  margin-top: 16px !important;
}

.ScoresTable-module__m-t-20___JDFUO {
  margin-top: 20px !important;
}

.ScoresTable-module__m-t-22___UamQp {
  margin-top: 22px !important;
}

.ScoresTable-module__m-t-30___YmAlY {
  margin-top: 30px !important;
}

.ScoresTable-module__m-t-32___K22yV {
  margin-top: 32px !important;
}

.ScoresTable-module__m-l-auto___v5JcR {
  margin-left: auto !important;
}

.ScoresTable-module__m-l-4___NFwmy {
  margin-left: 4px !important;
}

.ScoresTable-module__m-l-5___mtEAx {
  margin-left: 5px !important;
}

.ScoresTable-module__m-l-6___H0_fv {
  margin-left: 6px !important;
}

.ScoresTable-module__m-l-8___f7Kcb {
  margin-left: 8px !important;
}

.ScoresTable-module__m-l-10___WoQpN {
  margin-left: 10px !important;
}

.ScoresTable-module__m-l-16___bcfkx {
  margin-left: 16px !important;
}

.ScoresTable-module__m-l-20___FT38D {
  margin-left: 20px !important;
}

.ScoresTable-module__m-l-24___yGRvQ {
  margin-left: 24px !important;
}

.ScoresTable-module__m-l-30___LuUSU {
  margin-left: 30px !important;
}

.ScoresTable-module__m-l-35___CxZMz {
  margin-left: 35px !important;
}

.ScoresTable-module__m-l-40___jg812 {
  margin-left: 40px !important;
}

.ScoresTable-module__m-r-8___G3IFg {
  margin-right: 8px !important;
}

.ScoresTable-module__m-r-10___gSXhl {
  margin-right: 10px !important;
}

.ScoresTable-module__m-r-16___sOWGk {
  margin-right: 16px !important;
}

.ScoresTable-module__m-r-20___mLc7w {
  margin-right: 20px !important;
}

.ScoresTable-module__m-r-24___VOHqT {
  margin-right: 24px !important;
}

.ScoresTable-module__m-r-30___r3PNm {
  margin-right: 30px !important;
}

.ScoresTable-module__m-r-40___CDrZr {
  margin-right: 40px !important;
}

.ScoresTable-module__border-r-3___QtQc8 {
  border-radius: 3px !important;
}

.ScoresTable-module__border-r-4___A49th {
  border-radius: 4px !important;
}

.ScoresTable-module__border-r-6___vAz6R {
  border-radius: 6px !important;
}

.ScoresTable-module__border-r-10___XDmg1 {
  border-radius: 10px !important;
}

.ScoresTable-module__border-r-12___UJx7P {
  border-radius: 12px !important;
}

.ScoresTable-module__border-r-16___HJp0n {
  border-radius: 16px !important;
}

.ScoresTable-module__border-r-50___Tmq_h {
  border-radius: 50% !important;
}

.ScoresTable-module__primary-border___F4BHY {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ScoresTable-module__primary-border-b___cutqj {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ScoresTable-module__primary-border-t___ZXPq2 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ScoresTable-module__primary-border-l___jXkuw {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ScoresTable-module__primary-border-r___Ps0Mh {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ScoresTable-module__secondary-border___bgRnJ {
  border: 1px solid #637768;
}

.ScoresTable-module__secondary-border-b___eSeJ0 {
  border-bottom: 1px solid #637768;
}

.ScoresTable-module__secondary-border-t___tlN4Q {
  border-top: 1px solid #637768;
}

.ScoresTable-module__secondary-border-l___x1oIg {
  border-left: 1px solid #637768;
}

.ScoresTable-module__secondary-border-r___r6Ate {
  border-right: 1px solid #637768;
}

.ScoresTable-module__gap-0___ApOs9 {
  gap: 0 !important;
}

.ScoresTable-module__gap-2___aHlL9 {
  gap: 2px !important;
}

.ScoresTable-module__gap-4___pu9Q3 {
  gap: 4px !important;
}

.ScoresTable-module__gap-5___Ab2Ch {
  gap: 5px !important;
}

.ScoresTable-module__gap-6___OvO1v {
  gap: 6px !important;
}

.ScoresTable-module__gap-8___nkp2T {
  gap: 8px !important;
}

.ScoresTable-module__gap-10___XGsNi {
  gap: 10px !important;
}

.ScoresTable-module__gap-12___nPSv_ {
  gap: 12px !important;
}

.ScoresTable-module__gap-14___dtRGc {
  gap: 14px !important;
}

.ScoresTable-module__gap-16___clMlk {
  gap: 16px !important;
}

.ScoresTable-module__gap-18___YwY0z {
  gap: 18px !important;
}

.ScoresTable-module__gap-20___JXhew {
  gap: 20px !important;
}

.ScoresTable-module__gap-24___aC6Hc {
  gap: 24px !important;
}

.ScoresTable-module__gap-26___pkQG0 {
  gap: 26px !important;
}

.ScoresTable-module__gap-30___PUva5 {
  gap: 30px !important;
}

.ScoresTable-module__gap-32___oiSXy {
  gap: 32px !important;
}

.ScoresTable-module__gap-40___mvgra {
  gap: 40px !important;
}

.ScoresTable-module__gap-50___uBi8q {
  gap: 50px !important;
}

.ScoresTable-module__flex-1___dp2k4 {
  flex: 1;
}

.ScoresTable-module__flex-none___jjo4g {
  flex: none !important;
}

.ScoresTable-module__flex-column___i9Aye {
  display: flex;
  flex-direction: column !important;
}

.ScoresTable-module__flex-row___S3VAk {
  display: flex;
  flex-direction: row !important;
}

.ScoresTable-module__vertically-centered___v9q8L {
  display: flex;
  align-items: center !important;
}

.ScoresTable-module__horizontally-centered___oh4Rs {
  display: flex;
  justify-content: center !important;
}

.ScoresTable-module__horizontally-end___Tl8Bi {
  display: flex;
  justify-content: end !important;
}

.ScoresTable-module__vertically-start___qG3Kk {
  display: flex;
  align-items: start !important;
}

.ScoresTable-module__space-between___Mc_3l {
  display: flex;
  justify-content: space-between !important;
}

.ScoresTable-module__flex-wrap___o_IQF {
  flex-wrap: wrap !important;
}

.ScoresTable-module__height-100___DFrKl {
  height: 100%;
}

.ScoresTable-module__width-50___VeWuQ {
  width: 50% !important;
}

.ScoresTable-module__width-100___CsH20 {
  width: 100%;
}

.ScoresTable-module__cursor-pointer___IPivs {
  cursor: pointer;
}

.ScoresTable-module__cursor-not-allowed___KdyVG {
  cursor: not-allowed !important;
}

.ScoresTable-module__absolute-centered___s4huY {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ScoresTable-module__absolute___IvZvR {
  position: absolute;
}

.ScoresTable-module__relative___HCZLZ {
  position: relative;
}

.ScoresTable-module__fixed___efTKS {
  position: fixed;
}

.ScoresTable-module__visible___txEBM {
  opacity: 1;
}

.ScoresTable-module__invisible___izT_h {
  opacity: 0;
}

.ScoresTable-module__col-90___tJkx1 {
  width: 90% !important;
}

.ScoresTable-module__col-auto___yKfWc {
  width: auto !important;
}

.ScoresTable-module__medical-tabs___jpU_H {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ScoresTable-module__medical-table-new___bA431 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScoresTable-module__medical-table-new___bA431:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScoresTable-module__medical-table-new___bA431::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScoresTable-module__medical-table-new___bA431::-webkit-scrollbar-track {
  display: none;
}
.ScoresTable-module__medical-table-new___bA431.ScoresTable-module__no-pagination___yJaGQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScoresTable-module__medical-table-new___bA431.ScoresTable-module__no-pagination___yJaGQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScoresTable-module__medical-table-new___bA431.ScoresTable-module__no-pagination___yJaGQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScoresTable-module__medical-table-new___bA431.ScoresTable-module__no-pagination___yJaGQ::-webkit-scrollbar-track {
  display: none;
}

.ScoresTable-module__medical-table-empty___L7gWk {
  padding: 14px 40px !important;
}

.ScoresTable-module__icon-btn___XsY8a {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ScoresTable-module__search-icon___kg1DX {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ScoresTable-module__disable-select___CxGAj {
  user-select: none;
}

.ScoresTable-module__break-word___KeE34 {
  word-break: break-word;
}

.ScoresTable-module__popup-clear-btn___qAlaZ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ScoresTable-module__scroll-m-b-20___EGExq {
  scroll-margin-bottom: 20px;
}

.ScoresTable-module__header___yBbGB {
  color: #375844;
  width: 160px;
}

.ScoresTable-module__select___QEQwo {
  width: 200px;
}
.ScoresTable-module__select___QEQwo > div:first-child {
  padding: 4.5px 10px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/ScoresTable/ScoresTable.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,YAAA;AA8pBF;AA5pBE;EACE,8BAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  color: get-color(greenNew, dark);\n  width: 160px;\n}\n\n.select {\n  width: 200px;\n\n  & > div:first-child {\n    padding: 4.5px 10px !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ScoresTable-module__font-s-10___rfHGo`,
	"fontS12": `ScoresTable-module__font-s-12___GpcpO`,
	"fontS13": `ScoresTable-module__font-s-13___rdLZU`,
	"fontS14": `ScoresTable-module__font-s-14___gBOvf`,
	"fontS15": `ScoresTable-module__font-s-15___HAEhs`,
	"fontS16": `ScoresTable-module__font-s-16___JLxL4`,
	"fontS18": `ScoresTable-module__font-s-18___hVc3e`,
	"fontS20": `ScoresTable-module__font-s-20___l0UGf`,
	"fontS22": `ScoresTable-module__font-s-22___dhUmv`,
	"fontS28": `ScoresTable-module__font-s-28___nMoAV`,
	"fontW400": `ScoresTable-module__font-w-400___VMTp3`,
	"fontW500": `ScoresTable-module__font-w-500___b20JF`,
	"fontW600": `ScoresTable-module__font-w-600___vwDBN`,
	"fontW700": `ScoresTable-module__font-w-700___NeXqK`,
	"p5": `ScoresTable-module__p-5___hNCSd`,
	"p12": `ScoresTable-module__p-12___uti8o`,
	"p16": `ScoresTable-module__p-16___BrEc0`,
	"p30": `ScoresTable-module__p-30___oLTPq`,
	"pB0": `ScoresTable-module__p-b-0___nWl07`,
	"pB5": `ScoresTable-module__p-b-5___xahR_`,
	"pB10": `ScoresTable-module__p-b-10___PLMAf`,
	"pB12": `ScoresTable-module__p-b-12___g2zwV`,
	"pB16": `ScoresTable-module__p-b-16___EjSmY`,
	"pB18": `ScoresTable-module__p-b-18___g_tE1`,
	"pB20": `ScoresTable-module__p-b-20___Mzfxe`,
	"pB25": `ScoresTable-module__p-b-25___MTxkF`,
	"pB30": `ScoresTable-module__p-b-30___ac1W9`,
	"pB50": `ScoresTable-module__p-b-50___MSrJO`,
	"pT0": `ScoresTable-module__p-t-0___ozEO0`,
	"pT12": `ScoresTable-module__p-t-12___0n517`,
	"pT16": `ScoresTable-module__p-t-16___WvIqk`,
	"pT18": `ScoresTable-module__p-t-18___wvBxJ`,
	"pT20": `ScoresTable-module__p-t-20___NqrQb`,
	"pT30": `ScoresTable-module__p-t-30___foC3a`,
	"pT40": `ScoresTable-module__p-t-40___Pm2J6`,
	"pT50": `ScoresTable-module__p-t-50___h2FBZ`,
	"pL20": `ScoresTable-module__p-l-20___rUSKA`,
	"pL30": `ScoresTable-module__p-l-30___oH8xk`,
	"pL40": `ScoresTable-module__p-l-40___Xrqiv`,
	"pR16": `ScoresTable-module__p-r-16___coStE`,
	"pR20": `ScoresTable-module__p-r-20___jxqbD`,
	"pR30": `ScoresTable-module__p-r-30___CMsgf`,
	"pR50": `ScoresTable-module__p-r-50___Kri5s`,
	"pR60": `ScoresTable-module__p-r-60___CPhNn`,
	"mB1": `ScoresTable-module__m-b-1___EV6DG`,
	"mB2": `ScoresTable-module__m-b-2___ed9a_`,
	"mB6": `ScoresTable-module__m-b-6___wvxPG`,
	"mB8": `ScoresTable-module__m-b-8___eIuHs`,
	"mB10": `ScoresTable-module__m-b-10___A1yzC`,
	"mB14": `ScoresTable-module__m-b-14___I_KEc`,
	"mB16": `ScoresTable-module__m-b-16___buxR_`,
	"mB20": `ScoresTable-module__m-b-20___yS6tH`,
	"mB22": `ScoresTable-module__m-b-22___RrtAI`,
	"mB24": `ScoresTable-module__m-b-24___TaYwF`,
	"mB30": `ScoresTable-module__m-b-30___WVbVP`,
	"mB32": `ScoresTable-module__m-b-32___gOuQE`,
	"mB40": `ScoresTable-module__m-b-40___iRERl`,
	"mT2": `ScoresTable-module__m-t-2___GSUHy`,
	"mT3": `ScoresTable-module__m-t-3___U1Pt0`,
	"mT4": `ScoresTable-module__m-t-4___g5cIc`,
	"mT5": `ScoresTable-module__m-t-5___NTdoe`,
	"mT8": `ScoresTable-module__m-t-8___FDU5I`,
	"mT10": `ScoresTable-module__m-t-10___xdyfn`,
	"mT15": `ScoresTable-module__m-t-15___TuK0z`,
	"mT16": `ScoresTable-module__m-t-16___t04ig`,
	"mT20": `ScoresTable-module__m-t-20___JDFUO`,
	"mT22": `ScoresTable-module__m-t-22___UamQp`,
	"mT30": `ScoresTable-module__m-t-30___YmAlY`,
	"mT32": `ScoresTable-module__m-t-32___K22yV`,
	"mLAuto": `ScoresTable-module__m-l-auto___v5JcR`,
	"mL4": `ScoresTable-module__m-l-4___NFwmy`,
	"mL5": `ScoresTable-module__m-l-5___mtEAx`,
	"mL6": `ScoresTable-module__m-l-6___H0_fv`,
	"mL8": `ScoresTable-module__m-l-8___f7Kcb`,
	"mL10": `ScoresTable-module__m-l-10___WoQpN`,
	"mL16": `ScoresTable-module__m-l-16___bcfkx`,
	"mL20": `ScoresTable-module__m-l-20___FT38D`,
	"mL24": `ScoresTable-module__m-l-24___yGRvQ`,
	"mL30": `ScoresTable-module__m-l-30___LuUSU`,
	"mL35": `ScoresTable-module__m-l-35___CxZMz`,
	"mL40": `ScoresTable-module__m-l-40___jg812`,
	"mR8": `ScoresTable-module__m-r-8___G3IFg`,
	"mR10": `ScoresTable-module__m-r-10___gSXhl`,
	"mR16": `ScoresTable-module__m-r-16___sOWGk`,
	"mR20": `ScoresTable-module__m-r-20___mLc7w`,
	"mR24": `ScoresTable-module__m-r-24___VOHqT`,
	"mR30": `ScoresTable-module__m-r-30___r3PNm`,
	"mR40": `ScoresTable-module__m-r-40___CDrZr`,
	"borderR3": `ScoresTable-module__border-r-3___QtQc8`,
	"borderR4": `ScoresTable-module__border-r-4___A49th`,
	"borderR6": `ScoresTable-module__border-r-6___vAz6R`,
	"borderR10": `ScoresTable-module__border-r-10___XDmg1`,
	"borderR12": `ScoresTable-module__border-r-12___UJx7P`,
	"borderR16": `ScoresTable-module__border-r-16___HJp0n`,
	"borderR50": `ScoresTable-module__border-r-50___Tmq_h`,
	"primaryBorder": `ScoresTable-module__primary-border___F4BHY`,
	"primaryBorderB": `ScoresTable-module__primary-border-b___cutqj`,
	"primaryBorderT": `ScoresTable-module__primary-border-t___ZXPq2`,
	"primaryBorderL": `ScoresTable-module__primary-border-l___jXkuw`,
	"primaryBorderR": `ScoresTable-module__primary-border-r___Ps0Mh`,
	"secondaryBorder": `ScoresTable-module__secondary-border___bgRnJ`,
	"secondaryBorderB": `ScoresTable-module__secondary-border-b___eSeJ0`,
	"secondaryBorderT": `ScoresTable-module__secondary-border-t___tlN4Q`,
	"secondaryBorderL": `ScoresTable-module__secondary-border-l___x1oIg`,
	"secondaryBorderR": `ScoresTable-module__secondary-border-r___r6Ate`,
	"gap0": `ScoresTable-module__gap-0___ApOs9`,
	"gap2": `ScoresTable-module__gap-2___aHlL9`,
	"gap4": `ScoresTable-module__gap-4___pu9Q3`,
	"gap5": `ScoresTable-module__gap-5___Ab2Ch`,
	"gap6": `ScoresTable-module__gap-6___OvO1v`,
	"gap8": `ScoresTable-module__gap-8___nkp2T`,
	"gap10": `ScoresTable-module__gap-10___XGsNi`,
	"gap12": `ScoresTable-module__gap-12___nPSv_`,
	"gap14": `ScoresTable-module__gap-14___dtRGc`,
	"gap16": `ScoresTable-module__gap-16___clMlk`,
	"gap18": `ScoresTable-module__gap-18___YwY0z`,
	"gap20": `ScoresTable-module__gap-20___JXhew`,
	"gap24": `ScoresTable-module__gap-24___aC6Hc`,
	"gap26": `ScoresTable-module__gap-26___pkQG0`,
	"gap30": `ScoresTable-module__gap-30___PUva5`,
	"gap32": `ScoresTable-module__gap-32___oiSXy`,
	"gap40": `ScoresTable-module__gap-40___mvgra`,
	"gap50": `ScoresTable-module__gap-50___uBi8q`,
	"flex1": `ScoresTable-module__flex-1___dp2k4`,
	"flexNone": `ScoresTable-module__flex-none___jjo4g`,
	"flexColumn": `ScoresTable-module__flex-column___i9Aye`,
	"flexRow": `ScoresTable-module__flex-row___S3VAk`,
	"verticallyCentered": `ScoresTable-module__vertically-centered___v9q8L`,
	"horizontallyCentered": `ScoresTable-module__horizontally-centered___oh4Rs`,
	"horizontallyEnd": `ScoresTable-module__horizontally-end___Tl8Bi`,
	"verticallyStart": `ScoresTable-module__vertically-start___qG3Kk`,
	"spaceBetween": `ScoresTable-module__space-between___Mc_3l`,
	"flexWrap": `ScoresTable-module__flex-wrap___o_IQF`,
	"height100": `ScoresTable-module__height-100___DFrKl`,
	"width50": `ScoresTable-module__width-50___VeWuQ`,
	"width100": `ScoresTable-module__width-100___CsH20`,
	"cursorPointer": `ScoresTable-module__cursor-pointer___IPivs`,
	"cursorNotAllowed": `ScoresTable-module__cursor-not-allowed___KdyVG`,
	"absoluteCentered": `ScoresTable-module__absolute-centered___s4huY`,
	"absolute": `ScoresTable-module__absolute___IvZvR`,
	"relative": `ScoresTable-module__relative___HCZLZ`,
	"fixed": `ScoresTable-module__fixed___efTKS`,
	"visible": `ScoresTable-module__visible___txEBM`,
	"invisible": `ScoresTable-module__invisible___izT_h`,
	"col90": `ScoresTable-module__col-90___tJkx1`,
	"colAuto": `ScoresTable-module__col-auto___yKfWc`,
	"medicalTabs": `ScoresTable-module__medical-tabs___jpU_H`,
	"medicalTableNew": `ScoresTable-module__medical-table-new___bA431`,
	"noPagination": `ScoresTable-module__no-pagination___yJaGQ`,
	"medicalTableEmpty": `ScoresTable-module__medical-table-empty___L7gWk`,
	"iconBtn": `ScoresTable-module__icon-btn___XsY8a`,
	"searchIcon": `ScoresTable-module__search-icon___kg1DX`,
	"disableSelect": `ScoresTable-module__disable-select___CxGAj`,
	"breakWord": `ScoresTable-module__break-word___KeE34`,
	"popupClearBtn": `ScoresTable-module__popup-clear-btn___qAlaZ`,
	"scrollMB20": `ScoresTable-module__scroll-m-b-20___EGExq`,
	"header": `ScoresTable-module__header___yBbGB`,
	"select": `ScoresTable-module__select___QEQwo`
};
module.exports = ___CSS_LOADER_EXPORT___;
